import * as React from 'react';
import XSVG from './svg/XSVG';

export interface ModalCloseProps {
	toggle: () => void;
}

/**
 * Modal close component.
 *
 * @class ModalClose
 * @extends {React.Component<ModalCloseProps>}
 */
class ModalClose extends React.Component<ModalCloseProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		return (
			<div className="modal-close">
				<button className="modal-close__btn" onClick={this.props.toggle} data-testid="btn-modal-close">
					<span className="modal-close__text">close</span>
					<span className="modal-close__x">
						<XSVG class="modal-close__x-icon" />
					</span>
				</button>
			</div>
		);
	}
}

export default ModalClose;
